export default "__VITE_ASSET__BP14vI6o__"